import { render, staticRenderFns } from "./xuanzeLb.vue?vue&type=template&id=c4daf9ce&scoped=true&"
import script from "./xuanzeLb.vue?vue&type=script&lang=js&"
export * from "./xuanzeLb.vue?vue&type=script&lang=js&"
import style0 from "./xuanzeLb.vue?vue&type=style&index=0&id=c4daf9ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4daf9ce",
  null
  
)

export default component.exports